import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function RefreshIcon({ className, size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M12.0303 2.46967C11.7374 2.17678 11.2626 2.17678 10.9697 2.46967C10.6768 2.76256 10.6768 3.23744 10.9697 3.53033L11.6946 4.25523C7.00352 4.41615 3.25 8.26974 3.25 13C3.25 17.8325 7.16751 21.75 12 21.75C16.8325 21.75 20.75 17.8325 20.75 13C20.75 12.5858 20.4142 12.25 20 12.25C19.5858 12.25 19.25 12.5858 19.25 13C19.25 17.0041 16.0041 20.25 12 20.25C7.99594 20.25 4.75 17.0041 4.75 13C4.75 9.10231 7.82575 5.92301 11.6825 5.75683L10.9697 6.46967C10.6768 6.76256 10.6768 7.23744 10.9697 7.53033C11.2626 7.82322 11.7374 7.82322 12.0303 7.53033L14.0303 5.53033C14.3232 5.23744 14.3232 4.76256 14.0303 4.46967L12.0303 2.46967Z"
        fill="currentColor"
      />
    </svg>
  )
}
